import { isString } from 'antd/es/button';

export enum Month {
  JANUARI = 0,
  FEBRUARI = 1,
  MAART = 2,
  APRIL = 3,
  MEI = 4,
  JUNI = 5,
  JULI = 6,
  AUGUSTUS = 7,
  SEPTEMBER = 8,
  OKTOBER = 9,
  NOVEMBER = 10,
  DECEMBER = 11,
}

export const ConvertMonth = (month: string | number, lower?: boolean) => {
  if (isString(month)) {
    month = Number(month);
  }

  return lower ? Month[month - 1].toLowerCase() : Month[month - 1];
};
